import { render, staticRenderFns } from "./OrgPicker.vue?vue&type=template&id=95645d2e&scoped=true&"
import script from "./OrgPicker.vue?vue&type=script&lang=js&"
export * from "./OrgPicker.vue?vue&type=script&lang=js&"
import style0 from "./OrgPicker.vue?vue&type=style&index=0&id=95645d2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95645d2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\ele-dynamic-form\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95645d2e')) {
      api.createRecord('95645d2e', component.options)
    } else {
      api.reload('95645d2e', component.options)
    }
    module.hot.accept("./OrgPicker.vue?vue&type=template&id=95645d2e&scoped=true&", function () {
      api.rerender('95645d2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/OrgPicker.vue"
export default component.exports